import React from 'react';
import { titleMRClass } from "src/components/common/common";

interface KioskSwitchButtonFormProps {
  title?: string;
  value: 'Y' | 'N';
  onChange: (name: string, newValue: 'Y' | 'N') => void;
  name: string;
  editable?: boolean;
  titleless?: boolean;
  wrapperOption?: {
    wrapperStyle?: string;
    titleStyle?: string;
    inputStyle?: string;
  };
}

export const KioskSwitchButtonForm: React.FC<KioskSwitchButtonFormProps> = ({
  title,
  value,
  onChange,
  name,
  editable = true,
  titleless = false,
  wrapperOption = {
    wrapperStyle: "w-[250px] min-w-[250px] mr-[10px] mb-[5px]",
    titleStyle: "w-[120px] min-w-[120px] h-[34px] flex items-center",
    inputStyle: "w-auto min-w-0",
  },
}) => {

  const handleToggle = () => {
    if (editable) {
      onChange(name, value === 'Y' ? 'N' : 'Y');
    }
  };

  return (
    <div className={`flex items-center h-[34px] ${wrapperOption.wrapperStyle}`}>
      <p className={`${wrapperOption.titleStyle} form-title ${titleMRClass} ${titleless ? 'hidden' : ''}`}>
        {title}
      </p>
      <div
        className={`flex items-center ${wrapperOption.inputStyle} h-[34px]`}
        onClick={handleToggle}
      >
        <div
          className={`relative flex items-center shrink-0 w-[74px] h-[34px] box-border rounded-[4px] overflow-hidden border border-gray-300 transition-colors duration-300
						${editable
							? (value === 'Y' ? 'bg-blue-dark' : 'bg-gray-400') + ' cursor-pointer'
							: 'bg-gray-100 cursor-not-allowed'
						}`
					}
        >
          <div
            className={`absolute top-[2px] w-[34px] h-[28px] rounded-[2px] bg-white shadow-md transform transition-transform duration-200 ease-in-out
							${value === 'Y' ? 'translate-x-[2px]' : 'translate-x-[36px]'}`
						}
          />
          <span className={`absolute left-[12px] z-[1] text-[16px] leading-none font-semibold pointer-events-none ${value === 'Y' ? 'text-blue-dark' : 'text-gray-200'}`}>
            Y
          </span>
          <span className={`absolute right-[12px] z-[1] text-[16px] leading-none font-semibold pointer-events-none ${value === 'Y' ? 'text-gray-200' : 'text-gray-700'}`}>
            N
          </span>
        </div>
      </div>
    </div>
  );
};
